import { css, styled } from 'styled-components';
import { Media } from '../../../theme/Media';
import { CONTAINER_MAX_WIDTH_CSS, CONTAINER_PADDING_SM_MAX_CSS, CONTAINER_PADDING_SM_MIN_CSS } from './constants';
import { getGridLayoutStyles } from './gridStyles';
export const StyledContainer = styled.div `
  width: 100%;
  box-sizing: border-box;

  @media ${Media.smMin} {
    padding: 0 ${CONTAINER_PADDING_SM_MIN_CSS};
  }

  @media ${Media.xsMax} {
    padding: 0 ${CONTAINER_PADDING_SM_MAX_CSS};
  }

  ${({ $fluid }) => !$fluid &&
    css `
      max-width: ${CONTAINER_MAX_WIDTH_CSS};
      margin-left: auto;
      margin-right: auto;
    `}

  ${({ $layout }) => $layout !== undefined &&
    css `
      display: grid;
      align-items: flex-start;
      ${getGridLayoutStyles($layout)}

      > * {
        min-width: 0;
      }
    `}
`;
